interface KeyboardShortcutsProps {
  showModal: boolean
  onClose: () => void
  onOpen: () => void
}

export default function KeyboardShortcuts({ showModal, onClose, onOpen }: KeyboardShortcutsProps) {
  return (
    <>
      {/* Keyboard Shortcuts Help Modal */}
      {showModal && (
        <div className="fixed inset-0 z-[70] bg-black/40 backdrop-blur-sm flex items-center justify-center" onClick={onClose}>
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md mx-4 overflow-hidden" onClick={e => e.stopPropagation()}>
            <div className="px-6 py-5 border-b border-slate-100 flex items-center justify-between">
              <h3 className="text-lg font-bold text-slate-800">Keyboard Shortcuts</h3>
              <button onClick={onClose} className="text-slate-400 hover:text-slate-600 transition-colors">
                <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
            <div className="px-6 py-4 space-y-3">
              {[
                { keys: ['\u2318/', 'Ctrl+/'], desc: 'Open this help' },
                { keys: ['\u2318K', 'Ctrl+K'], desc: 'Focus drug search' },
                { keys: ['\u2318G', 'Ctrl+G'], desc: 'Generate letter' },
                { keys: ['\u2318D', 'Ctrl+D'], desc: 'Download as Word doc' },
                { keys: ['\u2318\u21E7A', 'Ctrl+Shift+A'], desc: 'Appeals Dashboard' },
                { keys: ['\u2318\u21E7P', 'Ctrl+Shift+P'], desc: 'Payer Directory' },
                { keys: ['Esc'], desc: 'Close modal / dropdown' },
              ].map(({ keys, desc }) => (
                <div key={desc} className="flex items-center justify-between py-1.5">
                  <span className="text-sm text-slate-600">{desc}</span>
                  <div className="flex items-center gap-1.5">
                    {keys.map((k, i) => (
                      <span key={i}>
                        {i > 0 && <span className="text-[10px] text-slate-300 mx-1">or</span>}
                        <kbd className="inline-block px-2 py-1 text-xs font-mono font-semibold text-slate-600 bg-slate-100 border border-slate-200 rounded-lg shadow-sm">{k}</kbd>
                      </span>
                    ))}
                  </div>
                </div>
              ))}
            </div>
            <div className="px-6 py-3 bg-slate-50 border-t border-slate-100">
              <p className="text-[11px] text-slate-400 text-center">Shortcuts with Cmd/Ctrl+G and Cmd/Ctrl+D are disabled while typing in inputs.</p>
            </div>
          </div>
        </div>
      )}

      {/* Floating Keyboard Shortcuts Button (FAB) */}
      <button
        onClick={onOpen}
        title="Keyboard shortcuts (\u2318/)"
        className="fixed bottom-4 right-4 w-10 h-10 bg-slate-100 hover:bg-slate-200 rounded-full shadow flex items-center justify-center text-lg transition-colors z-40 cursor-pointer"
      >
        <span role="img" aria-label="Keyboard shortcuts">{'\u2328\uFE0F'}</span>
      </button>
    </>
  )
}
